import { render, staticRenderFns } from "./delete-group-modal.vue?vue&type=template&id=9856b088&"
import script from "./delete-group-modal.vue?vue&type=script&lang=js&"
export * from "./delete-group-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports